import { useState } from "react";
import config from "../../../config/config";
import AddUserForm from "./addUserForm";
import { codService } from "../../../requests/codAdminService";
import { refreshDashboardData, refreshUserTableData } from "../../../observers/dataObserver";
import { userSession } from "../../../observers/userObserver";

// import { codService } from "../requests/codAdminService";
// import { propertyService } from "../requests/propertyService";

// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
};

const modalStyle = {
  background: "white",
  borderRadius: "8px",
  width: "320px",
  padding: "20px",
  position: "relative",
  textAlign: "left",
};

const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "transparent",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#333",
};

const AddUserFormModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({ email: "", userName: "" });
  const [loading, setLoading] = useState(false); // ✅ loader state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const [errorMessage, setErrorMessage] = useState("");
const [showErrorPopup, setShowErrorPopup] = useState(false)
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setErrorMessage("");
  setShowErrorPopup(false);
const token = userSession.getToken();

 userSession.getUserEmail()
  const requestorEmail = userSession.getUserEmail();
  const userType = userSession.getUserType();
console.log("🔍 userType from observer:", userType);




  try {
    let result;

    if (userType === "ADMN") {
      // ✅ Call /add_user API
      const response = await fetch(`${config["backend-url"]}/add_user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: formData.email,
          fullName: formData.userName,
          requestorEmail:requestorEmail,
          userType: "ADMN",
        }),
      });

      const data = await response.json();
      result = { ok: response.ok, data };
    } else {
      // ✅ Default COD API
      result = await codService.addUserFromCOD({
        email: formData.email,
        fullName: formData.userName,
        requestorEmail,
        token,
      });
    }

    if (result.ok) {
      console.log("✅ User added successfully:", result.data);
      setFormData({ email: "", userName: "" });
      refreshDashboardData.push("refresh");
      refreshUserTableData.push("refresh");
      onClose();
    } else {
      console.error("❌ Failed to add user:", result.data);
      const errorText = result.data?.error || result.data?.message || "Unknown error";
      setErrorMessage(`Failed to add user: ${errorText}`);
      setShowErrorPopup(true);
    }
  } catch (error) {
    console.error("❌ Network or server error:", error);
    setErrorMessage("Failed to add user");
    setShowErrorPopup(true);
  } finally {
    setLoading(false);
  }
};


  if (!show) return null;

  return (
    <div className="modal" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h4 style={{ marginTop: 0, marginBottom: "20px" }}>Add New User</h4>

        <button
          onClick={onClose}
          style={closeButtonStyle}
          aria-label="Close modal"
        >
          ×
        </button>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>⏳ Adding user...</div>
        ) : (
          <AddUserForm
            formData={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        )}
      </div>
      {showErrorPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        maxWidth: "400px",
        width: "90%",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
        textAlign: "center",
      }}
    >
      <p style={{ marginBottom: "15px"}}>{errorMessage}</p>
      <button
        onClick={() => setShowErrorPopup(false)}
        style={{
          padding: "8px 16px",
          backgroundColor: "#07b1b0",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Close
      </button>
    </div>
  </div>
)}
    </div>
  );
};

export default AddUserFormModal;
